import { FC } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';
import { Image, Icon, Button, baseVariables } from '@marriott/mi-ui-library';
import { ImageBannerProps } from './ImageBanner.types';
import { StyledImageBanner } from './ImageBanner.styles';
import { useMounted, useMediaQuery } from '../../hooks';

export const ImageBannerConfig = {
  emptyLabel: 'ImageBanner',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/shoppingpages/imagebanner`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ImageBanner: FC<{ model: ImageBannerProps }> = (props: any) => {
  const { dynamicMedia, dynamicMediaMobile, captionText, iconPath, linkUrl } = props.model;

  const isMounted = useMounted();
  const isTabletAndAbove = useMediaQuery(baseVariables.mediaQuery.md);

  if (!isMounted) {
    return null;
  }

  return (
    <EditableComponent config={ImageBannerConfig} {...props}>
      <StyledImageBanner data-testid="imagebanner" data-component-name="o-groups-imagebanner">
        {isTabletAndAbove && (
          <Image
            renditions={dynamicMedia?.renditions}
            dynamic={dynamicMedia?.dynamic}
            defaultImageURL={dynamicMedia?.assetPath}
            altText={dynamicMedia?.altText}
          />
        )}
        {!isTabletAndAbove && (
          <Image
            renditions={dynamicMediaMobile?.renditions}
            dynamic={dynamicMediaMobile?.dynamic}
            defaultImageURL={dynamicMediaMobile?.assetPath}
            altText={dynamicMediaMobile?.altText}
          />
        )}
        {captionText && (
          <div className="caption">
            <div className="t-label-inverse-xs">
              {iconPath && <Icon iconClass={clsx('caption-icon', iconPath)} ariaLabel={captionText} />}
              <Button
                isLink={true}
                href={linkUrl}
                target="_blank"
                className={clsx(iconPath && 'pl-2')}
                ariaLabel={captionText}
              >
                {captionText}
              </Button>
            </div>
          </div>
        )}
      </StyledImageBanner>
    </EditableComponent>
  );
};
